import React, { useCallback, useEffect, useRef, useState } from 'react'
import requestApi from '../../utils/request'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import TableListing from '../../components/TableListing/TableListing'
import Pagination from '../../components/Pagination'
import {
    createColumnHelper,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable
} from '@tanstack/react-table'
import DeleteModal from '../../components/DeleteModal/DeleteModal'
import { Dropdown, Form, InputGroup } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { ReactComponent as SearchIcon } from '../../assets/images/greysearch.svg'
import { ReactComponent as DeclineIcon } from '../../assets/images/decline.svg'
import { ReactComponent as ApproveIcon } from '../../assets/images/approve-icon.svg'
import { ReactComponent as DeleteIcon } from '../../assets/images/delete-icon-new.svg'
import { ReactComponent as IconView } from '../../assets/images/icons/icon-view-white.svg'
import { ReactComponent as IconsDots } from '../../assets/images/icons/icon-action-dots.svg'
import { ReactComponent as IconEdit } from '../../assets/images/icons/icon-edit-white.svg'
import { ReactComponent as IconDelete } from '../../assets/images/icons/icon-delete-white.svg'
import { ReactComponent as IconApproveRight } from '../../assets/images/icons/icon-right-aprrove.svg'
import { ReactComponent as IconDesapproveClose } from '../../assets/images/icons/icon-close-desaprrove.svg'
import Swal from 'sweetalert2'
import { buyerview, viewbuyerdetails } from '../../config/routingConsts'
import { useNavigate } from 'react-router-dom'
import ImageZoomModal from '../../components/ImageZoomModal/ImageZoomModal'
import TableSkeleton from '../../components/TableSkeleton/TableSkeleton'

const BuyerManagement = () => {
    const navigate = useNavigate()

   const [imageShow,setImageShow] = useState(false)
   const [imageGet,setImageGet] = useState(false)

    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchKeyword, setSearchKeyword] = useState('')
    const [sorting, setSorting] = useState([])
    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [deleteId, setDelteId] = useState('')
    const [ShowMaterialStatusPopup, setShowMaterialStatusPopup] =
        useState(false)
    const queryClient = useQueryClient()
    const EditDataRef = useRef(null)
    const [statusUpdate, setStatusUpdate] = useState(null)
    const [buttonText, setButtonText] = useState('')

    const { register, handleSubmit } = useForm()

    const handleDeleteModal = (id) => {
        setIsDeleteModal(true)
        setDelteId(id)
    }

    
    useEffect(()=>{
        setCurrentPage(1)
     },[searchKeyword])

    const handleSearch = useCallback((e) => {
        setCurrentPage(1)
        const getData = setTimeout(() => {
            setSearchKeyword(e.target.value)
        }, 1000)
        clearInterval()
    }, [])

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    const handleChange = (eventkey) => {
        setDataLimit(eventkey)
    }

    function handleDelete(materialId) {
        mutationDelete.mutate(materialId)
        setIsDeleteModal(false)
    }

    async function deleteMaterialId(userId) {
        return await requestApi.post(`user/delete`, {
            userId
        })
    }

    const mutationDelete = useMutation(deleteMaterialId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('userList')
            setIsDeleteModal(false)
            EditDataRef.current = null
        },
        onError: (error) => {
            EditDataRef.current = null
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })

    function userList({ queryKey }) {
        return requestApi
            .post(
                `user/list`,
                {
                    limit: queryKey[2],
                    page: queryKey[1],
                    search: queryKey[3],
                    sortKey: '',
                    sortBy: 1
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const { data,isLoading } = useQuery({
        queryKey: [
            'userList',
            currentPage,
            DataLimit,
            searchKeyword,
            sorting[0]
        ],
        queryFn: userList
    })

    useEffect(() => {
        if (currentPage && data?.data?.length == 0) {
            setCurrentPage(currentPage - 1)
        } else {
        }
    }, [currentPage, data?.data])

    
    useEffect(()=>{
        setCurrentPage(1)
     },[searchKeyword])

    const [openAction, setopenAction] = useState(null)
    const OpenAction = (id) => {
        setopenAction(openAction === id ? null : id)
    }

    function onStatusChange(e) {
        if (e.detail == 2) {
            alert('hello')
        }
    }


    
    const handleImageZoomModal=(imagePath)=>{
        setImageShow(true)
        setImageGet(imagePath)
    }

    //#region  Table columns
    const columnHelper = createColumnHelper()

    const columns = [
        columnHelper.display({
            id: 'profilePic',
            header: 'Image',
            enableSorting: false,
            cell: (row) => {
                return (
                    <div className='product-thumbnail'>
                        <img
                            src={row?.row?.original?.profilePic}
                            alt="user_Img"
                            onClick={()=> handleImageZoomModal(row?.row?.original?.profilePic)}
                        />
                    </div>
                )
            }
        }),    
        columnHelper.accessor((row) => row?.firstName, {
            id: 'firstName',
            header: () => 'First Name',
            cell: (row) => {
                return (
                    <span>{row?.row?.original?.firstName}</span>
                )
            }
        }),

        columnHelper.accessor((row) => row?.lastName, {
            id: 'lastName',
            header: () => 'Last Name',
            cell: (row) => {
                return (
                    <span>{row?.row?.original?.lastName}</span>
                )
            }
        }),

        columnHelper.accessor((row) => row?.email, {
            id: '   email',
            header: () => 'Email',
            cell: (row) => {
                return (
                    <span>
                        { row?.row?.original?.email}
                    </span>
                )
            }
        }),

        columnHelper.accessor((row) => row?.phoneNo, {
            id: 'phoneNo',
            header: () => 'Phone No',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.phoneNo
                            ?row?.row?.original?.phoneNo
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.display({
            id: 'Action',
            header: 'Action',
            cell: (row) => {
                return (
                    <>
                        <div className="action-data">
                                    <div
                                        className={`table-action ${
                                            row?.row?.original?.userId ===
                                            openAction
                                                ? 'active'
                                                : ''
                                        }`}
                                        onMouseLeave={() => setopenAction(null)}
                                    >
                                        <div
                                            className={`action-btn ${
                                                row?.row?.original?.userId ===
                                                openAction
                                                    ? 'active'
                                                    : ''
                                            }`}
                                            onClick={() =>
                                                OpenAction(
                                                    row?.row?.original?.userId
                                                )
                                            }
                                        >
                                            <IconsDots />
                                        </div>
                                        <div className="action-panel two-action">
                                            <div
                                                className="action-btn-icon view"
                                                onClick={() => {
                                                    navigate(
                                                        `${viewbuyerdetails}/${row?.row?.original?.userId}`
                                                    )
                                                }}
                                            >
                                                <IconView />
                                            </div>
                                            <div
                                                className="action-btn-icon delete"
                                                onClick={() =>
                                                    handleDeleteModal(
                                                        row?.row?.original
                                                            ?.userId
                                                    )
                                                }
                                            >
                                                <IconDelete />
                                            </div>
                                        </div>
                                    </div>
                        </div>
                    </>
                )
            }
        })
    ]
    //#endregion

    const table = useReactTable({
        data: data?.data || [],
        columns: columns,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    return (
        <>
            <div className="material-management">
                <div className="admin-card">
                    <div class="head">
                        <h2>Buyer Management</h2>
                        <div className="search-btn-group">
                            <form  {...register('userSearch', {
                                onChange: (e) => {
                                    handleSearch(e)
                                }
                            })}
                            className="product-table-filter">
                                 <input
                                type="search"
                                name="userSearch"
                                placeholder="Search"
                            />
                            </form>
                        </div>
                    </div>
                </div>
            { isLoading ? (
                      <TableSkeleton />
                  ) :
                  data?.data?.length > 0 ? (
                    <>
                        <TableListing table={table} className="m-0"
                          parentLink={viewbuyerdetails}  keyValue="userId"
                          isLink excludes={['Action','profilePic']}
                        />
                        <div className="pagination-wrap">
                            <div className="showing-pages">
                                <span>
                                    Showing {(currentPage - 1) * DataLimit + 1} to{' '}
                                    {Math.min(
                                        currentPage * DataLimit,
                                        data.meta.totalCount
                                    )}{' '}
                                    of {data.meta.totalCount} buyers
                                </span>
                            </div>
                            {data?.meta?.totalCount > 10 && (
                                <>
                                    <Pagination
                                        total={Math.ceil(data.meta.totalCount/DataLimit)}
                                        current={currentPage}
                                        onChangePage={handleChangePage}
                                    />
                                </>
                            )}
                        </div>
                    </>
                ) : (
                   <div className='no-record-found'>
                      No Record Found
                   </div>
                )
                  }

                <DeleteModal
                    message={
                        <>
                            Are you sure you want to <br /> Delete this buyer ?
                        </>
                    }
                    setIsDeleteModal={setIsDeleteModal}
                    isDeleteModal={isDeleteModal}
                    handleDelete={() => handleDelete(deleteId)}
                />
            </div>

            <ImageZoomModal imageShow={imageShow} setImageShow={setImageShow}  imageGet={imageGet}/>
        </>
    )
}

export default BuyerManagement
